import React, { Component } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Content.scss";
import LatestData from "../../data/latest.json";
import { db } from "../../firebase";
import { collection, getDocs, query } from "firebase/firestore";

class Content extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filtered: [],
      isLoading: true,
      searchValue: "",
      posts: []
    };
  }

  async componentDidMount() {
    this.fetchPostsFromFirestore();

    setTimeout(() => this.setState({ isLoading: false }), 1000);
  }

  fetchPostsFromFirestore = async () => {
    try {
      const q = query(collection(db, "posts"));
      const querySnapshot = await getDocs(q);
      const posts = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      this.setState({ posts }, () => this.filterContent());
    } catch (error) {
      console.error("Błąd podczas pobierania postów:", error);
      this.setState({ posts: [] }, () => this.filterContent());
    }
  };

  componentDidUpdate(prevProps) {
    if (this.props.currentPath !== prevProps.currentPath) {
      this.filterContent();
    }
  }

  filterContent = () => {
    const isFairyTales = this.props.currentPath.includes("/bajki");
    const localData = LatestData.latest[
        isFairyTales ? "fairy-tales" : "articles"
        ];

    const allPosts = [...this.state.posts, ...localData];

    this.setState({
      filtered: allPosts,
    });
  };

  searchContent(event) {
    const searchValue = event.target.value;
    let currentList = [];
    let newList = [];

    if (searchValue !== "") {
      currentList = this.state.filtered;

      newList = currentList.filter((item) =>
          item.header.toLowerCase().includes(searchValue.toLowerCase())
      );
    } else {
      newList = this.state.filtered;
    }

    this.setState({ filtered: newList, searchValue });
  }

  render() {
    return (
        <div>
          <div className={this.state.isLoading ? "loading-spinner" : ""}></div>
          {this.props.currentPath.includes("/bajki") && (
              <input
                  className="article__search"
                  name="text"
                  type="text"
                  placeholder="Wyszukaj bajkę..."
                  onChange={(event) => this.searchContent(event)}
                  value={this.state.searchValue}
              />
          )}
          <div className="article">
            {this.state.filtered.map((latest, index) => {
              const image =
                  latest.imageUrl || `/img/${latest.slug}.jpg`;

              return (
                  <Link
                      to={`/${
                          this.props.currentPath.includes("/bajki") ? "bajki" : "artykuly"
                      }/${latest.slug}`}
                      className="article__box"
                      key={index}
                  >
                    <h1 className="article__header">{latest.header}</h1>
                    <p className="article__description">{latest.description}</p>
                    <img
                        className="article__image"
                        src={image}
                        alt="drobinek"
                    ></img>
                  </Link>
              );
            })}
          </div>
        </div>
    );
  }
}

export default function ContentWrapper(props) {
  const location = useLocation();
  return <Content {...props} currentPath={location.pathname}/>;
}
